import React, { useState, useEffect, useCallback, useContext } from "react";

//context
import { AuthContext } from "../../../../common/middlewares/Auth";

// Import componentes de Material-ui
import { TextField, Box, CircularProgress, MenuItem, Alert, AlertTitle, FormHelperText } from "@mui/material";

import { createStyles } from "@mui/material/styles";
//  import de paquetes de funciones Axios;
import axios from "axios";

const stylesTipoRetiro = createStyles(() => ({
  InputBase: {
    color: "#999999",
  },
}));

const GetTipoEncuesta = ({ value, handlerChangeData, errors, helperText, success }) => {
  const classes = stylesTipoRetiro();
  const [data, setData] = useState();
  const [error, setError] = useState({
    flag: false,
    msg: undefined,
  });
  const [load, setLoad] = useState(false);

  const authContext = useContext(AuthContext);
  const { token } = authContext;

  const getData = useCallback(
    async (signalGetData) => {
      setLoad(true);
      await axios({
        method: "GET",
        baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
        url: `${process.env.REACT_APP_API_GETLISTA_ENCUESTARETIRO}`,
        params: {
          strCodigo: "Tipo Encuesta",
        },
        headers: {
          token,
        },
        cancelToken: signalGetData.token,
      })
        .then((res) => {
          if (res.data.error) {
            throw new Error(res.data.msg);
          }
          setLoad(false);
          setData(res.data.data);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.error(error);
            setLoad(false);
            setError({
              flag: true,
              msg: error.message,
            });
          }
        });
    },
    [token]
  );

  useEffect(() => {
    const signalGetData = axios.CancelToken.source();
    getData(signalGetData);
    return () => {
      signalGetData.cancel("Abort peticion");
    };
  }, [getData]);

  if (load) {
    return (
      <Box display="flex" alignContent="center" alignItems="center">
        <CircularProgress size={30} />
      </Box>
    );
  }
  if (error.flag) {
    return (
      <Alert severity="error">
        <AlertTitle>
          <b>{error.msg}</b>
        </AlertTitle>
        Ha ocurrido un error al obtener los datos
      </Alert>
    );
  }
  if (!data || data.length === 0) {
    return (
      <Alert severity="info">
        <AlertTitle>
          <b>Data not found</b>
        </AlertTitle>
        No existen datos de carga para mostrar
      </Alert>
    );
  }
  return (
    <>

      <TextField
        label="Tipo de retiro"
        select
        fullWidth
        InputProps={{ style: classes.InputBase }}
        error={errors}
        helperText={helperText}
        disabled={success ? true : false}
        name="strTipoEncuesta"
        id="cbx_strTipoEncuesta"
        onChange={(e) => handlerChangeData(e)}
        value={value}
      >
        {data.map((i) => {
          return (
            <MenuItem key={i} value={i.strCodigoRetorno}>
              {i.strCodigoRetorno}
            </MenuItem>
          );
        })}
      </TextField>

      {/* Texto pequeño debajo del select */}
      {!value && (
        <FormHelperText sx={{ color: "error.main", mt: 1 }}>
          Debes seleccionar un tipo de encuesta
        </FormHelperText>
      )}

    </>
  );
};

export default GetTipoEncuesta;
